import { render } from "./ZhiZaoProcessKanBan.vue?vue&type=template&id=63731106&scoped=true"
import script from "./ZhiZaoProcessKanBan.vue?vue&type=script&lang=js"
export * from "./ZhiZaoProcessKanBan.vue?vue&type=script&lang=js"

import "./ZhiZaoProcessKanBan.vue?vue&type=style&index=0&id=63731106&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63731106"]])

export default __exports__